import { __decorate, __metadata } from 'tslib';
import { Service } from '../../decorators/class/service.js';
import { KeymapService } from '@tencent/docs-keymap';
import { UIService } from '../../controllers/base/ui-service.js';
import { ServiceNames } from '../../constants/service-name.js';
import { evaluate } from '../../controllers/base/evaluate.js';
import { setActionPointEvent } from '../../providers/action-point/action-point-runner.js';

/**
 * 用于管理全局快捷键的服务
 *
 * @public
 */
let KeymapServiceWrapper = class KeymapServiceWrapper extends UIService {
    constructor() {
        super();
        this.instanceMap = new Map();
        const defaultService = new KeymapService();
        this.instanceMap.set('default', defaultService);
    }
    // TODO: @ziofatli, @icyflzhang KeymapService无需强制更新，review这里接口合理性
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    $forceUpdate() {
    }
    onUpdate() {
        this.configs.getAllKeys().forEach((key) => {
            this.syncToKeybindingService(key);
        });
    }
    syncToKeybindingService(key) {
        const mergedConfig = this.getMergedConfig(key);
        let instance = this.instanceMap.get('default');
        // 如果用户指定了 node
        if (mergedConfig === null || mergedConfig === void 0 ? void 0 : mergedConfig.node) {
            // 判断是否存在实例 不存在新建
            if (this.instanceMap.get(mergedConfig.node)) {
                instance = this.instanceMap.get(mergedConfig.node);
            }
            else {
                instance = new KeymapService(mergedConfig.node);
                this.instanceMap.set(mergedConfig.node, instance);
            }
        }
        if (mergedConfig) {
            // workbench,keymap对外重新包装keymap的名称
            const keybindingConfig = Object.assign(Object.assign({}, mergedConfig), { weight: mergedConfig.priority, when: (event) => {
                    setActionPointEvent(mergedConfig.shouldDisabled, event);
                    return !evaluate(mergedConfig.shouldDisabled, false);
                }, handler: (event) => {
                    const { onPress } = mergedConfig;
                    setActionPointEvent(onPress, event);
                    onPress();
                } });
            const existed = instance.get(mergedConfig.keyBindings)
                .find(item => item.name === mergedConfig.name);
            if (existed) {
                Object.assign(existed, keybindingConfig);
            }
            else {
                instance.register(keybindingConfig);
            }
        }
    }
};
KeymapServiceWrapper = __decorate([
    Service({ overridable: true, scope: 'ui:service', name: ServiceNames.KEYMAP }),
    __metadata("design:paramtypes", [])
], KeymapServiceWrapper);

export { KeymapServiceWrapper };
//# sourceMappingURL=keymap-service.js.map
